import React, {Component, useState} from 'react'
import Hero from '../components/Home/Hero'
import SEO from "../components/seo"
import Layout from "../components/layout"

const Home = ({}) => {
  return (
    <Layout>
        <SEO
            title="Home"
            description={"The ultimate game for art world enthusiasts looking to educate themselves about artists around the world and across time."}
        />
        <Hero/>
    </Layout>
  )
};

export default Home
